// endpoint authentication
export const AUTH_ENDPOINTS = {
  LOGIN: "/api/v1/consumers/auth/sign-in",
  VERIFYOTP: "/api/v1/consumers/auth/verify-otp",
  VERIFY_OTP_SIGUP: "/api/v1/consumers/auth/verify-otp-signup",
  LOGOUT: "/api/v1/consumers/auth/logout",
  REGISTER: "/api/v1/consumers/auth/signup",
  RESEND_OTP_SIGN_UP: "/api/v1/consumers/auth/resend-otp-signup",
};

// endpoint other
export const ENDPOINTS = {
  //Profile
  GET_USER_INFO: "/api/v1/consumers/auth/me",
  UPDATE_USER_INFO: "/api/v1/consumers/auth/update-profile",
  POST_IMAGE_UPLOAD: "/api/v1/upload_file",
  UPDATE_AVATAR: "/api/v1/consumers/update-avatar",
  //Quest
  QUEST_LIST: "/api/v1/consumers/quests/list",
  TAKE_QUEST: "/api/v1/consumers/quests/questions",
  POST_ANSWERS: "/api/v1/consumers/quests/answers",
  POST_TAKE_QUEST_PRACTICE: "/api/v1/consumers/quests/practice",
  GET_QUEST_DETAILS: "/api/v1/consumers/quests/detail",
  GET_QUEST_DETAILS_PUBLIC: "/api/v1/public/quest/detail",
  GET_QUEST_HISTORY: "/api/v1/consumers/quests/history",
  INBOX_LIST: "/api/v1/consumers/notifications/list",
  POST_READ_INBOX: "/api/v1/consumers/notifications/mark-all-read",
  GET_UNREAD_INBOX: "/api/v1/consumers/notifications/count_unread_notification",
  POST_QUEST_RECEIPT: "/api/v1/consumers/quests/participant/receipt",
  POST_QUEST_COMPLETE: "/api/v1/consumers/quests/complete",
  POST_QUEST_REVIEW: "/api/v1/consumers/quests/participant/review",
  FAVORITE_QUEST: "/api/v1/consumers/quests/favorite",
  POST_END_QUEST: "/api/v1/consumers/quests/participant/quit",
  QUEST_PER_LOCATION_LIST: "/api/v1/public/quest/list",
  SAVE_QUEST: "/api/v1/consumers/quests/participant/save_quest",
  GET_QUEST_PER_LOCATION: "/api/v1/consumers/locations/quest-near",
  GET_DETAIL_PARTICIPANT: "/api/v1/consumers/quests/participant/detail",
  GET_LIST_ONGONG_QUEST_PER_LOCATION:
    "/api/v1/consumers/quests/list-perlocation",
  GET_FAVORITE_LOCATION: "/api/v1/consumers/locations/favorite",
  GET_LOCATION_BY_LAT_LONG: "/api/v1/consumers/locations/location-by-lat-long",
  POST_PAUSE_TIMER_PARTICIPANT: "/api/v1/consumers/quests/participant/pause",
  GET_EXTENSION_TIME_PARTICIPANT: "/api/v1/consumers/quests/extension-time",
  POST_START_QUEST_PARTICIPANT: "/api/v1/consumers/quests/participant/start",
  //Tutorials
  TUTORIALS_CONSUMERS: "/api/v1/consumers/tutorials",
  POST_TUTORIALS_STATUS: "/api/v1/consumers/tutorials/read_complete",
  NEXT_TUTORIALS: "/api/v1/consumers/tutorials/next_tutorial",
  //Withdraw
  POST_WITHDRAW: "/api/v1/consumers/withdraw",
  GET_WITHDRAW_HISTORY: "/api/v1/consumers/historywithdraw",
  GET_WITHDRAW_DETAILS: "/api/v1/consumers/historywithdraw",
  CALCULATE_TOKEN: "/api/v1/consumers/calculate-token",

  //Contact
  POST_CONTACT: "/api/v1/consumers/contact-us",

  // Location
  FAVORITE_LOCATION: "/api/v1/consumers/locations/favorite",
};
